// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { StudentCertificateRepresentation } from './StudentCertificateRepresentation'
import {
  StudentCertificateRepresentationFromJSON,
  StudentCertificateRepresentationFromJSONTyped,
  StudentCertificateRepresentationToJSON,
} from './StudentCertificateRepresentation'

/**
 *
 * @export
 * @interface StudentCertificateRepresentationBaseApiListResult
 */
export interface StudentCertificateRepresentationBaseApiListResult {
  /**
   *
   * @type {Array<StudentCertificateRepresentation>}
   * @memberof StudentCertificateRepresentationBaseApiListResult
   */
  data: Array<StudentCertificateRepresentation>
  /**
   *
   * @type {number}
   * @memberof StudentCertificateRepresentationBaseApiListResult
   */
  total: number
}

/**
 * Check if a given object implements the StudentCertificateRepresentationBaseApiListResult interface.
 */
export function instanceOfStudentCertificateRepresentationBaseApiListResult(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'data' in value
  isInstance = isInstance && 'total' in value

  return isInstance
}

export function StudentCertificateRepresentationBaseApiListResultFromJSON(
  json: any,
): StudentCertificateRepresentationBaseApiListResult {
  return StudentCertificateRepresentationBaseApiListResultFromJSONTyped(
    json,
    false,
  )
}

export function StudentCertificateRepresentationBaseApiListResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StudentCertificateRepresentationBaseApiListResult {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: (json['data'] as Array<any>).map(
      StudentCertificateRepresentationFromJSON,
    ),
    total: json['total'],
  }
}

export function StudentCertificateRepresentationBaseApiListResultToJSON(
  value?: StudentCertificateRepresentationBaseApiListResult | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data: (value.data as Array<any>).map(
      StudentCertificateRepresentationToJSON,
    ),
    total: value.total,
  }
}
